import { render, staticRenderFns } from "./appointRecords.vue?vue&type=template&id=c2f0e7a8&scoped=true"
import script from "./appointRecords.vue?vue&type=script&lang=js"
export * from "./appointRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f0e7a8",
  null
  
)

export default component.exports